import { createStore } from "redux";
import rootReducers from "./reducers";

const ativaReduxDevTools = process.env.REACT_APP_ENV !== "production" && window["__REDUX_DEVTOOLS_EXTENSION__"];

const store = createStore(rootReducers, ativaReduxDevTools && window["__REDUX_DEVTOOLS_EXTENSION__"]());

export default store;
